import React, {FC} from "react";
import {HiddenWrapper} from "./type";
import {isHidden} from "mixins/helpers";

const HiddenWrapper: FC<HiddenWrapper.Props> = (props: HiddenWrapper.Props) => {
    return (
        props.config ?
        ((props.mode !== 'edit' && props.config && !props.config.isHidden) || (props.mode === 'edit')) && (
            <div className={`${props.mode} ${isHidden(props.config.isHidden)}`}>
                {props.mode === 'edit' && props.config.isHidden && (
                    <div className="hidden-block-notice">Блок скрыт</div>
                )}

                {props.children}
            </div>
        ) : props.children
    );
};

export default HiddenWrapper;
